import React from 'react';
import FeaturesTemplate from "../../../common/components/FeaturesTemplate";
import img1 from "/public/recharge/features/_1.png"
import img2 from "/public/recharge/features/_2.png"
import img3 from "/public/recharge/features/_3.png"
import useTranslation from "next-translate/useTranslation";
import {RC_NAMESPACE} from "../../../../utils/i18nNameSpaces";

const Features = () => {
  const {t} = useTranslation(RC_NAMESPACE);

  const imgList = [
    img1,
    img2,
    img3
  ]

  const cards = [
    {
      icon: null,
      title: t("features._1.title"),
      desc: t("features._1.desc")
    },
    {
      icon: null,
      title: t("features._2.title"),
      desc: t("features._2.desc")
    },
    {
      icon: null,
      title: t("features._3.title"),
      desc: t("features._3.desc")
    },
  ]

  return (
    <>
      <FeaturesTemplate namespace={RC_NAMESPACE} cards={cards} imgList={imgList}/>
    </>
  );
};

export default Features;